// Shared success DTO for Detail and Calculate (default/preview/checkout_prepare)
// only. Never apply to App Bar, Start, Confirm, errors or legacy snapshots.
// Canonical scalar types are retained: tier_level string|null, money strings,
// coupon IDs/counters number|null, coupon booleans and shipping flags string|null.
// Provider extensions and nullable metadata are deliberately not traversed.
const array = value => Array.isArray(value) ? value : []
const object = value => value && typeof value === 'object' && !Array.isArray(value) ? value : null

function arrays (source, keys) {
  const result = { ...source }
  keys.forEach(key => { result[key] = array(source[key]) })
  return result
}

function product (source) {
  return {
    ...arrays(source, ['product_free', 'price_badges', 'price_badges_calculation', 'list_category', 'list_manufacturer', 'list_supplier', 'wholesale', 'flash_sale', 'bundle', 'fix_price_json', 'percent_discount_json', 'group_tier_json']),
    tier_level: source.tier_level == null ? null : source.tier_level
  }
}

function warranty (value) {
  const quote = object(value)
  return quote ? { ...quote, lines: array(quote.lines) } : null
}

function parcel (source) {
  return {
    ...source,
    products: array(source.products).map(product),
    product_free: array(source.product_free).map(product),
    shipping_options: array(source.shipping_options).map(option => ({ ...option, items: array(option.items) })),
    estimate_request_id: source.estimate_request_id == null ? '' : source.estimate_request_id,
    selected_shipping: object(source.selected_shipping),
    shipping_data: object(source.shipping_data),
    summary: object(source.summary),
    warranty: warranty(source.warranty)
  }
}

function shop (source) {
  return {
    ...arrays(source, ['coupon', 'payment_method', 'seller_shop_badges']),
    parcels: array(source.parcels).map(parcel),
    product_free: array(source.product_free).map(product),
    tier: array(source.tier).map(tier => ({ ...tier, tier_level: tier.tier_level == null ? null : tier.tier_level })),
    bundle: object(source.bundle),
    summary: object(source.summary),
    warranty: warranty(source.warranty),
    type_shipping: source.type_shipping == null ? null : source.type_shipping,
    date_pickup: source.date_pickup == null ? null : source.date_pickup,
    time_pickup: source.time_pickup == null ? null : source.time_pickup,
    pickup_detail: object(source.pickup_detail)
  }
}

export function mapCartResponse (response) {
  if (!response || response.code !== 200 || !response.data || !Array.isArray(response.data.shop_list) ||
    !(response.success === true || response.data.success === true || String(response.result).toUpperCase() === 'SUCCESS')) return response
  const data = response.data
  // A legacy fallback can share this envelope without the parcel projection.
  // Keep it intact instead of creating empty parcels that hide its products.
  if (data.shop_list.some(shop => !Array.isArray(shop.parcels))) return response
  return {
    ...response,
    data: {
      ...arrays(data, ['payment_method', 'coupon']),
      checkout: object(data.checkout),
      summary: object(data.summary),
      product_free: array(data.product_free).map(product),
      shop_list: data.shop_list.map(shop)
    }
  }
}
